function asyncLoad(img) {
  img.setAttribute('src', img.dataset.src);
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('img[data-src]').forEach(asyncLoad);
});
